
import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';
const swal = require('sweetalert');

//import { Role } from './../../settings/view-userdetails/view-userdetails.component';

@Component({
  selector: 'app-order-type',
  templateUrl: './order-type.component.html',
  styleUrls: ['./order-type.component.scss']
 // providers:[OrderService] ,
})
export class OrderTypeComponent implements OnInit {
  isReadytoUpdateordertype:boolean=false;
  merchantdata: UserPOSData ;
  isNewOrderType: boolean = true;
  isUpdateOrderType: boolean = false;
  rows;

  OrderType= new FormControl("", [Validators.required]);
  DefaultOrderType: boolean = false;
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);
  constructor( private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: OrderService,
    private commonfunction: CommonFunctionService) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetOrderTypeDetails();
  }
  
 
  getGetOrderTypeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetOrderTypeDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.id>0) {
      this.DefaultOrderType=result.defaultOrderType;
        this.isUpdateOrderType = true;
        this.isNewOrderType = false;
        this.rows = result;
      } else {
        this.isUpdateOrderType = false;
        this.isNewOrderType = true;
      }
    });
 
  }


  DefaultOrderType1()
  {
    this.DefaultOrderType=!this.DefaultOrderType;
  }

  onKey()
  {
    this.isReadytoUpdateordertype = true;
  }

  
  newOrderType() {
   
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      OrderType  :"",
      DefaultOrderType :false,
      };
    form.OrderType = this.OrderType.value;
    form.DefaultOrderType = this.DefaultOrderType;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
   
    this.service.AddOrderType(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        localStorage.removeItem('ordertypelist');
        swal("Added", "Order Type Added Successfully !", "success");
        this.router.navigate(["/pos/ordertype/manage"]);
    }
    });
  }

  updateOrderType()
  {
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      OrderType :"",
      DefaultOrderType :false,
      id:""
      };
    form.OrderType = this.OrderType.value;
    form.DefaultOrderType = this.DefaultOrderType;
    form.id=this.rows.id;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
  
    this.service.UpdateOrderType(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        localStorage.removeItem('ordertypelist');
        swal("Added", "Order Type Updated Successfully !", "success");
        this.router.navigate(["/pos/ordertype/manage"]);
      }
    });
  }


  ordertypeError() {
    return this.OrderType.hasError("required") ? "OrderType is required"
       : this.OrderType.hasError("pattern") ? "OrderType should be allow only alphabets" : "";
   }















}



